enum FundingWindowTriggerType {
    FirstDeposit = "FIRST_DEPOSIT",
    MinimumBalanceMet = "MINIMUM_BALANCE_MET"
}
export default FundingWindowTriggerType